import { render, staticRenderFns } from "./PageMockExam.vue?vue&type=template&id=68572a16&scoped=true"
import script from "./PageMockExam.vue?vue&type=script&lang=js"
export * from "./PageMockExam.vue?vue&type=script&lang=js"
import style0 from "./PageMockExam.vue?vue&type=style&index=0&id=68572a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68572a16",
  null
  
)

export default component.exports